import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericBaseService } from './generic-base.service';
import { onErrorCallbackInterface } from '../interfaces/interfaces';
import { PaymentAction, PaymentActionIgnoreList } from '../models/payment-action.model';
import { PaymentOption } from '../models/payment-option.model';
import { TranslateService } from '@ngx-translate/core';
import { ApiVersion, UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class PaymentActionService extends GenericBaseService {
  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected translateService: TranslateService,
    protected url: UrlService
  ) {
    super('Payment Action', httpClient, toastrService, url, ApiVersion.v2);
  }

  getPaymentOptions(companySlug: string, slug: string, afterGetCallback?: Function, customMessage?: string): void {
    return this.getNow<PaymentOption>(
      `/payment-action/${companySlug}/${slug}`,
      undefined,
      afterGetCallback,
      customMessage,
      true,
      false,
      true
    );
  }

  createPaymentAction(
    paymentAction: PaymentAction,
    afterPostCallback?: Function,
    customMessage?: string,
    onErrorCallback?: onErrorCallbackInterface
  ): void {
    return this.postNow(
      '/payment-action',
      this.getBody(paymentAction, PaymentActionIgnoreList),
      afterPostCallback,
      customMessage,
      true,
      false,
      false,
      onErrorCallback
    );
  }

  putPaymentAction(
    paymentActionId: string,
    paymentActionUpdateModel: any,
    afterPutCallback?: () => void,
    customMessage?: string,
    onErrorCallback?: onErrorCallbackInterface
  ): void {
    return this.putNow(
      `/payment-action/${paymentActionId}`,
      this.getBody(paymentActionUpdateModel, PaymentActionIgnoreList),
      afterPutCallback,
      customMessage,
      true,
      false,
      onErrorCallback
    );
  }

  createPaymentUrl(
    paymentId: string,
    paymentAmount: number,
    afterGetCallback?: (paymentUrl: string) => void,
    customMessage?: string): void {
    return this.getNow<any>(
      `/payment-action/payment-link/${paymentId}?amount=${paymentAmount}`,
      undefined,
      afterGetCallback,
      customMessage,
      true,
      false,
      true
    );
  }

  copyPaymentActionUrl(companySlug: string, slug: string, companyName: string): void {
    if (!companySlug || companySlug.length === 0) {
      this.translateService.get([
          'paymentActions.copyFailedMessageTitle',
          'company.missingCompanySlugMessage'
        ],
        {CompanyName: companyName}
      ).subscribe((translations: string[]) => {
        this.toastrService.error(
          translations['company.missingCompanySlugMessage'],
          translations['paymentActions.copyFailedMessageTitle']
        );
      });
      return;
    }

    const paymentUrl: string = this.getPaymentActionUrl(companySlug, slug);

    navigator.clipboard.writeText(paymentUrl);

    this.translateService.get('paymentActions.copySuccessMessage').subscribe((message: string) => {
      this.toastrService.success(message);
    });
  }

  getPaymentActionUrl(companySlug: string, slug: string): string | null {
    if (!companySlug || companySlug.length === 0) {
      return null;
    }
    return this.url.getDashboardUrl('payments', companySlug, slug);
  }

  deletePaymentAction(paymentActionId: string, afterDeleteCallback?: () => void, customMessage?: string): void {
    return this.deleteNow(
      `/payment-action/${paymentActionId}`,
      afterDeleteCallback,
      customMessage
    );
  }
}
